/*
 * 各ページからimport必須
 */
import _MEISHIBANK2 from 'static/config'
import RepositoryFactory from '@/repositories/RepositoryFactory'

export default {
  beforeRouteUpdate (to, from, next) {
    // 機能内の画面遷移した場合、フラッシュメッセージを解除する
    if (to.name !== from.name) {
      this.$store.commit('setFlashMessages', [])
    }
    next()
  },
  data: function () {
    return {
      MEISHIBANK2: _MEISHIBANK2,
      scrollBody: document.body,
      errorTitle: '',
      errors: [],
      successTitle: '',
      successes: [],
      infoTitle: '',
      messages: [],
      app_lang: {
        NO_INPUT: '(未入力)',
        NO_SELECT: '(未指定)',
        NO_SET: '(未設定)',
        NO_EDIT: '(更新しません)',
        NO_DATE: '(無期限)'
      },
      app_flag: {
        ON: '1',
        OFF: '0'
      },
      app_imgsrc: {
        now_loading: '/static/images/com/image-loading.png',
        no_image: '/static/images/com/image-none.png',
        not_found: '/static/images/com/image-404.png'
      },
      app_interval: {
        getResult: 1000,
        appSuiteJobStatus: 1000
      },
      app_maxdate: '0', // DatePicker用
      maxlength_date: 10 // 検索用の文字列長
    }
  },
  computed: {
    isAgentPage: function () {
      return this.$store.state.base.u &&
        this.$store.getState('login_user') &&
        this.$store.getState('login_user').as_agent
    },
    isAdminPage: function () {
      // 第一階層のルートを見る
      return !!(this.$route.matched[0] && this.$route.matched[0].meta.isAdminPage)
    },
    isMgmt: function () {
      return this.$store.state.base.u && this.$store.getState('isMgmt')
    },
    isReloadGuardPage: function () {
      // 第一階層、第二階層のルートを見る
      return !!(this.$route.matched[0] && this.$route.matched[0].meta.isReloadGuardPage) ||
        !!(this.$route.matched[1] && this.$route.matched[1].meta.isReloadGuardPage)
    },
    /**
     * NISFA機能のライセンスを持っているかどうか
     * @return boolean 契約済みならばtrue
     */
    hasNisfaLicense () {
      const license = (this.$store.state.base.u && this.$store.getState('license')) || {}
      return license.option_nisfa_integration === this.app_flag.ON
    },
    /**
     * NISFA機能を使えるかどうか（システムとして使用できるか）
     * 個人の判断は別
     * @return boolean 契約済みかつ、会社設定で有効化されていればtrue
     */
    isNisfaEnabled () {
      const nisfa = (this.$store.state.base.u && this.$store.getState('nisfa_integration')) || {}
      return this.hasNisfaLicense && nisfa.enable === this.app_flag.ON
    },
    /**
     * ログインユーザーがNISFA機能を使えるかどうか
     * @return boolean 契約済みかつ、会社設定、個人設定で有効化されていればtrue
     */
    isNisfaPvEnabled () {
      const nisfa = (this.$store.state.base.u && this.$store.getState('nisfa_integration')) || {}
      return this.isNisfaEnabled && (nisfa.pv_enable === this.app_flag.ON)
    }
  },
  methods: {
    clearMessages: function () {
      this.clearErrorMessages()
      this.clearSuccessMessages()
      this.clearInfoMessages()
      this.clearDefaultMessages()
    },
    clearErrorMessages: function () {
      this.errors = []
      this.errorTitle = ''
    },
    clearSuccessMessages: function () {
      this.successes = []
      this.successTitle = ''
    },
    clearInfoMessages: function () {
      this.messages = []
      this.infoTitle = ''
    },
    clearDefaultMessages: function () {
    },
    /**
     * トーストメッセージを表示する
     * @params {string} htmlMessage
     * @params {object} option
     *    {string} dest
     *    {string} type
     */
    showToast: function (htmlMessage, option) {
      const vm = this
      const toastBox = document.body.getElementsByClassName('toast-box')[0]
      const toast = document.createElement('div')
      toast.setAttribute('data-testid', '-toast')
      const toast_text = document.createElement('div')
      toast_text.setAttribute('data-testid', '-toast-text')
      const toast_clear = document.createElement('div')
      toast_clear.setAttribute('data-testid', '-toast-clear')
      option = option || {}

      toast.className = 'toast'
      if (option.type) {
        toast.className += ' toast-' + option.type
      }
      toast_text.className = 'toast-text'
      toast_text.innerHTML = htmlMessage
      toast_clear.className = 'toast-btn-clear'
      toast_clear.innerHTML = '<i class="fa fa-close"></i>'
      toast.appendChild(toast_clear)
      toast.appendChild(toast_text)

      toastBox.insertBefore(toast, toastBox.firstChild)
      toast.className += ' show'

      // 表示した後10秒後に消す
      const removeToast = setTimeout(function () {
        vm._removeToast(toast)
      }, 10000)

      toast_clear.addEventListener('click', function (e) {
        e.preventDefault()
        vm._removeToast(toast)
        // タイマーを解除する
        clearTimeout(removeToast)
      })

      // IEでanchorでの遷移が効かないためイベントを登録
      if (option.dest) {
        const link = document.getElementById('bcard-toast-link')
        link.addEventListener('click', function (e) {
          vm.$router.push({name: option.dest})
        })
      }
    },
    _removeToast: function (toast) {
      const toastBox = document.body.getElementsByClassName('toast-box')[0]
      // トーストが表示されている場合、トーストを削除する
      if (toastBox.getElementsByClassName(toast.className).length) {
        toastBox.removeChild(toast)
      }
    },
    // 改行をBRタグに変換する
    nl2br: function (str) {
      return str ? str.replace(/\n/g, '<br>') : ''
    },
    /**
     *  ダウンロード処理を行う
     * @param {string} repo: RepositoryFactory.getに使う名前
     * @param {string} method name
     * @param filename DLファイル名
     * @param {object} args methodの引数に渡すデータ
     */
    getFileDL: function (repo, method, filename, ...args) {
      const vm = this

      // ダウンロード処理を行う
      const options = {responseType: 'blob'}
      return RepositoryFactory.get(repo)[method](options, ...args)
        .then(function (response) {
          if (window.navigator.msSaveBlob) {
            // IE用ダウンロード処理
            window.navigator.msSaveBlob(new Blob([response.data], {'type': response.data.type}), filename)
          }
          else {
            const url = window.URL.createObjectURL(new Blob([response.data], {'type': response.data.type}))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        })
        .catch(function (error) {
          // エラーメッセージもBlobオブジェクトで返ってくるので、データを読み出してsetErrorMessage()で読み込める形式にする
          // Blobデータを読み出す
          const blob = error.response.data
          const reader = new FileReader()
          reader.addEventListener('loadend', function () {
            // 結果のテキスト形式をオブジェクトに変換して、エラーメッセージを表示できる形式にする
            const errorObj = {'response': JSON.parse(reader.result)}
            vm.setErrorMessage(errorObj)
          })
          reader.readAsText(blob)
        })
    },
    /**
     * エラーメッセージからアプリエラーコードを抽出する
     */
    getAppErrCode: function (errorMessage) {
      if (!errorMessage) {
        return ''
      }
      const splitted = errorMessage.split('#')
      return splitted.length === 1 ? '' : splitted.pop()
    },
    /**
     * IE11 includes() 未実装
     * 互換関数
     */
    isIncludes: function (array, searchElem) {
      for (let item of array) {
        if (item === searchElem) {
          return true
        }
      }

      return false
    },
    /**
     * formdataにFile情報を追加する
     * @param FormData formData
     * @return FormData
     */
    appendFiles: function (formData, isSingle) {
      const files = this.$store.getState('files')
      if (isSingle) {
        formData.append('file', files.pop())
      }
      else {
        let fileIndex = 0
        for (let file of files) {
          formData.append('files[' + fileIndex + ']', file)
          fileIndex++
        }
      }
      formData.delete('_files')
      return formData
    },
    /**
     * 各要素に部署名を連結した値を追加する
     * @param depts 部署名(1から3まで対応)
     * @param delimiter 区切り文字
     * @return 連結後の部署名
     */
    implodeDept: function (depts, delimiter = ', ') {
      // null または 連想配列以外の場合は、空文字を返す
      if (typeof depts !== 'object' || depts === null) {
        return ''
      }
      let deptList = []
      deptList.push('dept' in depts ? depts.dept : '')
      deptList.push('dept2' in depts ? depts.dept2 : '')
      deptList.push('dept3' in depts ? depts.dept3 : '')

      // 部署名[1-3]を一つにまとめる
      let deptMerged = ''
      deptList.map(function (dept) {
        if (dept != null && dept.length !== 0) {
          // 追記の場合はデリミタを付ける
          if (deptMerged.length !== 0) {
            deptMerged += delimiter
          }
          // 部署名を連結する
          deptMerged += dept || ''
        }
      })

      return deptMerged
    },
    scrollToTop: function () {
      document.documentElement.scrollTop = document.body.scrollTop = 0
    },
    getScrollTop: function () {
      // REF https://stackoverflow.com/questions/45061901/chrome-61-body-doesnt-scroll
      return document.documentElement.scrollTop || document.body.scrollTop
    },
    enableScroll: function () {
      this.scrollBody.style.overflow = 'auto'
    },
    disableScroll: function () {
      this.scrollBody.style.overflow = 'hidden'
    },
    /**
     * 使い方
     * this.loadMaxlengths('Mgtags')
     */
    loadMaxlengths: function (tableName) {
      let maxlengths = {}
      try {
        maxlengths = require('../config/config.define.maxlengths.json')[tableName] || {}
        // console.log(maxlengths)
      }
      catch (e) {
        // console.log(e)
      }
      return maxlengths
    },
    /**
     * 使い方
     * this.loadConfigEnv('NUM_BCARD_IMAGES_MAX_LIMIT')
     */
    loadConfigEnv: function (name) {
      let value
      try {
        value = require('../config/config.env.json')[name] || {}
      }
      catch (e) {
        // console.log(e)
      }
      return value
    },
    /**
     * ブラウザクッキー入出力
     * @see https://developer.mozilla.org/ja/docs/Web/API/Document/cookie#Example_2_Get_a_sample_cookie_named_test2
     */
    setCookie: function (key, value) {
      // 有効期限 約10年 (3650 * 24 * 60 * 60)
      document.cookie = encodeURIComponent(key) + '=' + encodeURIComponent(value) + ';max-age=315360000'
    },
    getCookie: function (key) {
      const regex = new RegExp('(?:(?:^|.*;\\s*)' + key + '\\s*\\=\\s*([^;]*).*$)|^.*$')
      return decodeURIComponent(document.cookie.replace(regex, '$1'))
    },
    delCookie: function (key) {
    },
    /**
     * sessionStorage入出力
     */
    resetSession: function () {
      // 初期化
      sessionStorage.setItem(this.MEISHIBANK2.sessionStorage.key, JSON.stringify({'searched': false}))
    },
    setSession: function (key, value) {
      const sessionKey = this.MEISHIBANK2.sessionStorage.key
      let storage = JSON.parse(sessionStorage.getItem(sessionKey))
      if (!storage) {
        storage = {}
      }
      storage[key] = value
      sessionStorage.setItem(sessionKey, JSON.stringify(storage))
    },
    getSession: function (key) {
      const storage = JSON.parse(sessionStorage.getItem(this.MEISHIBANK2.sessionStorage.key))
      if (!storage || !storage.hasOwnProperty(key)) {
        return null
      }
      return storage[key]
    },
    /**
     * 設定したファイルが登録サイズ上限を超えていないか、0でないかを確認する
     * @param file ファイルオブジェクト
     * @param maxsize 最大サイズ(byte) 0は無制限
     * @param toErrorMessage エラーメッセージを返すフラグ
     * @return int|string|boolean エラーメッセージ(正常時は空文字となる) | エラーコード
     */
    checkFileSize: function (file, maxsize, toErrorMessage = false) {
      let ret = true
      if (file.size <= 0) {
        ret = -1
      }
      else if (maxsize > 0 && file.size > maxsize) {
        ret = -2
      }

      if (toErrorMessage) {
        if (ret === -1) {
          return '0バイトのファイルは添付できません。'
        }
        else if (ret === -2) {
          return 'ファイル「' + file.name + '」は ' + this.convertUnit(maxsize) + ' を超えるため添付できません。この設定は管理者が変更できます。'
        }
        else {
          return ''
        }
      }
      else {
        return ret
      }
    },
    /**
     * 単位を変換する
     * @param size サイズ(byte)
     * @param unit 単位をつけるかどうか
     * @return 変換後の単位
     */
    convertUnit: function (size, unit = true) {
      const units = ['B', 'KB', 'MB', 'GB']
      let nowUnit = 'B'
      let tmpSize = size

      // byteから、変換できる最大単位まで変換する
      for (let i = 0; i < units.length; i++) {
        // この単位で1未満になる場合は、単位を設定して終了する
        if (tmpSize < 1024) {
          nowUnit = units[i]
          break
        }

        // 単位繰り上げ
        tmpSize = Math.round(tmpSize / 1024)
      }
      // 数値処理を行う
      tmpSize = new Intl.NumberFormat().format(tmpSize)
      // 単位を付ける
      if (unit === true) {
        tmpSize = tmpSize + ' ' + nowUnit
      }

      return tmpSize
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/app.js